import { LOGS_REQUEST } from '@/store/actions/logs';
import { AUTH_LOGOUT } from '@/store/actions/auth';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'change-logs',
  components: {},
  props: [],
  data () {
    return {
      logs: {data: []},
    }
  },
  computed: {
    ...mapState({
      dataLoading: state => state.logs.status === 'loading',
      // loginError: state => state.auth.status === 'error',
    }),
    ...mapGetters([
      'getLogs'
    ]),
  },
  mounted () {
    this.$store.dispatch(LOGS_REQUEST).then((response) => {
      this.logs = response.data;
    }).catch((error) => {
      this.handleUnauth(error.response.status);
      this.handleForbidden(error.response.status);
    });
  },
}
